import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import { IStyleProps } from './types';

const useStyles = makeStyles({
  dropzone: {
    display: 'flex',
    justifyContent: 'center',
    cursor: (props: IStyleProps) => (props.isDisabled ? 'no-drop' : 'pointer'),
    margin: '0px 24px 8px 24px',
    border: '1px dashed',
    padding: '20px',
    color: 'rgba(0, 0, 0, 0.12)',
  },
  format: {
    marginLeft: '40px',
    color: '#00000099',
  },
  backupIcon: {
    marginRight: '16px',
    marginTop: '-4px',
    color: colors.primary,
  },
  chooseFile: {
    color: colors.primary,
    marginRight: '4px',
    fontSize: '14px',
  },
  dragHere: {
    color: 'black',
    fontSize: '14px',
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    height: '64px',
    padding: '0 24px',

    '& > *:first-child': {
      marginRight: '16px',
    },
  },
  files: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '30px 24px 0px 28px',
  },
  filesText: {
    display: 'flex',
    flexDirection: 'row',
  },
  fileIcon: {
    marginRight: '8px',
    color: colors.trueBlack,
  },
});

export default useStyles;
